/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatchReadyReportResponse } from './MatchReadyReportResponse';
import {
    MatchReadyReportResponseFromJSON,
    MatchReadyReportResponseFromJSONTyped,
    MatchReadyReportResponseToJSON,
    MatchReadyReportResponseToJSONTyped,
} from './MatchReadyReportResponse';
import type { MatchTeamReadinessResponse } from './MatchTeamReadinessResponse';
import {
    MatchTeamReadinessResponseFromJSON,
    MatchTeamReadinessResponseFromJSONTyped,
    MatchTeamReadinessResponseToJSON,
    MatchTeamReadinessResponseToJSONTyped,
} from './MatchTeamReadinessResponse';

/**
 * 
 * @export
 * @interface MatchReadinessResponse
 */
export interface MatchReadinessResponse {
    /**
     * 
     * @type {Array<MatchReadyReportResponse>}
     * @memberof MatchReadinessResponse
     */
    reports: Array<MatchReadyReportResponse>;
    /**
     * 
     * @type {MatchTeamReadinessResponse}
     * @memberof MatchReadinessResponse
     */
    team1: MatchTeamReadinessResponse;
    /**
     * 
     * @type {MatchTeamReadinessResponse}
     * @memberof MatchReadinessResponse
     */
    team2: MatchTeamReadinessResponse;
    /**
     * 
     * @type {string}
     * @memberof MatchReadinessResponse
     */
    verifiedMatchKey?: string;
    /**
     * True when stored reports disagree on the match key — wrong-lobby signal
     * @type {boolean}
     * @memberof MatchReadinessResponse
     */
    hasConflict: boolean;
}

/**
 * Check if a given object implements the MatchReadinessResponse interface.
 */
export function instanceOfMatchReadinessResponse(value: object): value is MatchReadinessResponse {
    if (!('reports' in value) || value['reports'] === undefined) return false;
    if (!('team1' in value) || value['team1'] === undefined) return false;
    if (!('team2' in value) || value['team2'] === undefined) return false;
    if (!('hasConflict' in value) || value['hasConflict'] === undefined) return false;
    return true;
}

export function MatchReadinessResponseFromJSON(json: any): MatchReadinessResponse {
    return MatchReadinessResponseFromJSONTyped(json, false);
}

export function MatchReadinessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchReadinessResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'reports': ((json['reports'] as Array<any>).map(MatchReadyReportResponseFromJSON)),
        'team1': MatchTeamReadinessResponseFromJSON(json['team1']),
        'team2': MatchTeamReadinessResponseFromJSON(json['team2']),
        'verifiedMatchKey': json['verifiedMatchKey'] == null ? undefined : json['verifiedMatchKey'],
        'hasConflict': json['hasConflict'],
    };
}

export function MatchReadinessResponseToJSON(json: any): MatchReadinessResponse {
    return MatchReadinessResponseToJSONTyped(json, false);
}

export function MatchReadinessResponseToJSONTyped(value?: MatchReadinessResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reports': ((value['reports'] as Array<any>).map(MatchReadyReportResponseToJSON)),
        'team1': MatchTeamReadinessResponseToJSON(value['team1']),
        'team2': MatchTeamReadinessResponseToJSON(value['team2']),
        'verifiedMatchKey': value['verifiedMatchKey'],
        'hasConflict': value['hasConflict'],
    };
}

